import { ActionIcon, Box, Button, Group, Modal, Text } from "@mantine/core";
import { IconDotsVertical } from "@tabler/icons-react";
import { useState } from "react";
import { setProjectDashboardActiveLayoutInRedux } from "../../app/routes/projectdashboard/projectDashboardSlice";
import { useAppDispatch, useAppSelector } from "../../hooks";

const WidgetWrapper: React.FC<{
  title?: string;
  widgetKey?: string;
  customTitle?: React.ReactNode;
  customButtons?: React.ReactNode;
  allowFullscreen?: boolean;
  width?: string | number;
  onShowSettingsClick?: (arg) => void;
  onFullscreenClick?: (arg) => void;
}> = ({
  title,
  widgetKey,
  customTitle,
  customButtons,
  allowFullscreen,
  width = "80vw",
  onShowSettingsClick,
  onFullscreenClick,
  children,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const editDashboardMode = useAppSelector((state) => state.projectDashboardReducer.editMode);
  const activeLayout = useAppSelector((state) => state.projectDashboardReducer.activeLayout);
  const dispatch = useAppDispatch();

  const handleRemoveWidget = () => {
    const updateLayoutGrid = activeLayout.layoutGrid.filter((obj) => {
      return obj.i !== widgetKey;
    });
    const layout = { ...activeLayout, layoutGrid: updateLayoutGrid };
    dispatch(setProjectDashboardActiveLayoutInRedux(layout));
  };
  return (
    <Box w="100%" h="100%" p="xs" pos="relative" style={{ display: "flex", flexDirection: "column" }}>
      <Group justify="space-between" align="center" gap="xs" wrap="nowrap" style={{ width: "100%" }} mb="xs">
        <Box style={{ flex: 1, minWidth: 0 }}>
          {(title || customTitle) && (
            <Group gap={4} align="center" wrap="nowrap" style={{ minWidth: 0 }}>
              {title && (
                <Text
                  fz="md"
                  style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flexGrow: 1 }}
                >
                  {title}
                </Text>
              )}
              {customTitle}
            </Group>
          )}
        </Box>
        <Group gap="xs" align="center" wrap="nowrap" style={{ flexShrink: 0 }}>
          {customButtons}
          {editDashboardMode === true && (
            <Button
              variant="danger-filled"
              size="xs"
              px="xs"
              onClick={handleRemoveWidget}
              style={{ zIndex: 6 }}
              aria-label="Fjern widget"
            >
              <i className="fa fa-close fa-fw" />
            </Button>
          )}
          {onFullscreenClick != null && editDashboardMode === false && (
            <ActionIcon
              variant="subtle"
              color="warmgray.8"
              size="sm"
              px="xs"
              onClick={onFullscreenClick}
              aria-label="Fullskjerm"
            >
              <i className="fa fa-expand fa-md" />
            </ActionIcon>
          )}
          {allowFullscreen === true && (
            <ActionIcon
              variant="subtle"
              color="warmgray.8"
              size="sm"
              px="xs"
              onClick={() => setModalOpen((o) => !o)}
              aria-label="Fullskjerm"
            >
              <i className="fa fa-expand fa-md" />
            </ActionIcon>
          )}
          {onShowSettingsClick != null && editDashboardMode === false && (
            <ActionIcon
              variant="subtle"
              color="warmgray.8"
              size="sm"
              onClick={onShowSettingsClick}
              aria-label="Innstillinger"
            >
              <div>
                <IconDotsVertical size={22} />
              </div>
            </ActionIcon>
          )}
        </Group>
      </Group>
      {children}
      {allowFullscreen === true && (
        <Modal
          opened={modalOpen}
          onClose={() => setModalOpen(false)}
          title={title}
          size={width}
          centered
          withinPortal
          overlayProps={{ blur: 2 }}
        >
          <Box p="xs">{children}</Box>
        </Modal>
      )}
    </Box>
  );
};

export default WidgetWrapper;
